import * as Yup from 'yup';

export const EsqueciASenhaValidacao = Yup.object().shape({
  email: Yup.string().email('Informe um email válido!').required('Você deve informar um email!'),
});
